<template>
  <div :class="classes">
    <dx-avatar
      :name="avatar"
      :nickname="nickname"
      />
    <div class="dx-player__points">
      {{ points }}
    </div>
  </div>
</template>

<script>
import DxAvatar from './DxAvatar.vue'
export default {
  name: 'dx-player',
  components: { DxAvatar },
  props: {
    avatar: String,
    points: {
      type: Number,
      default: 0
    },
    active: {
      type: Boolean,
      default: false
    },
    mediator: {
      type: Boolean,
      default: false
    },
    user: Object
  },
  computed: {
    classes () {
      return {
        'dx-player': true,
        'dx-player--active': this.active,
        'dx-player--mediator': this.mediator
      }
    },
    nickname () {
      if (this.user) {
        return this.user.nickname
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DxPlayer.vue